import React from "react";
import Link from "next/link";

interface LogoGraphicProps {
  src: string;
  alt: string;
}

const LogoGraphic: React.FC<LogoGraphicProps> = ({ src, alt }) => (
  <img
    src={src}
    alt={alt}
    className="shrink-0"
    width={60}
    height={30}
    loading="eager"
    fetchPriority="high"
    decoding="sync"
  />
);

const Logo: React.FC = () => (
  <Link href="/" className="flex gap-4 text-xl font-bold text-slate-200">
    <LogoGraphic src="/images/aleger-color-logo.svg" alt="Andrew Leger Logo" />
    <span className="hidden sm:inline [font-family:Arial,Helvetica,sans-serif] text-slate-200">ANDREW LEGER</span>
  </Link>
);

export default Logo;
